export const colorPink = "#eddfe5";
export const colorLightPink ="#fff0f6"
export const colorPrimary="#601350"
export const colorBorder="#42474e"
export const outlineColor="#83727c"
export const textColor="#21191e"
export const neutralBlack="#2f3033"
export const backGround= "linear-gradient(to top, #005230, #601350)"
export const colorNavbar="#2F3033"
export const colorOrange="#F6921E"
export const colorLeft="#FFF8F9"

 
